import { KpiCalculationType } from "../enums/kpi-calculation-type.enum";
import { Currency } from "../models/general/currency.model";
import { ListItem } from "../models/list-item.model";

export abstract class GoalsHelper {
    

    public static quarters = [{id: null, name: '---'}, { id: 1, name: 'Q1' }, { id: 2, name: 'Q2' }, { id: 3, name: 'Q3' }, { id: 4, name: 'Q4'}] as ListItem[];
 
    public static getQuarter(quarter: number): string {
      return GoalsHelper.quarters.find(item => item.id == quarter).name;
    }
    
    public static currencyList: Currency[] = [
        { code: 'HUF', symbol: 'Ft', name: 'Magyar forint' },
        { code: 'EUR', symbol: '€', name: 'Euró' },
        //{ code: 'USD', symbol: '$', name: 'USA dollár' },
        // { code: 'JPY', symbol: '¥', name: 'Japán jen' },
        // { code: 'GBP', symbol: '£', name: 'Brit font sterling' },
        // { code: 'AUD', symbol: 'A$', name: 'Ausztrál dollár' },
        // { code: 'CAD', symbol: 'C$', name: 'Kanadai dollár' },
        // { code: 'CHF', symbol: 'CHF', name: 'Svájci frank' },
        // { code: 'CNY', symbol: '¥', name: 'Kínai jüan' },
        // { code: 'HKD', symbol: 'HK$', name: 'Hongkongi dollár' },
        // { code: 'NZD', symbol: 'NZ$', name: 'Új-zélandi dollár' },
        // { code: 'SEK', symbol: 'kr', name: 'Svéd korona' },
        // { code: 'NOK', symbol: 'kr', name: 'Norvég korona' },
        // { code: 'DKK', symbol: 'kr', name: 'Dán korona' },
        // { code: 'PLN', symbol: 'zł', name: 'Lengyel zloty' },
        // { code: 'CZK', symbol: 'Kč', name: 'Cseh korona' },
        // { code: 'SGD', symbol: 'S$', name: 'Szingapúri dollár' },
        // { code: 'KRW', symbol: '₩', name: 'Dél-koreai von' },
        // { code: 'INR', symbol: '₹', name: 'Indiai rúpia' },
        // { code: 'BRL', symbol: 'R$', name: 'Brazil real' }
    ];

    public static getCurrency(code: string): Currency {
        return GoalsHelper.currencyList.find(c => c.code === code);
    }

    public static calculateKPIRatio(planned: number, achieved: number, calculationType: KpiCalculationType, maxResult?: number): number {
        let ratio = 0;

        switch (calculationType)
        {
            case KpiCalculationType.GreaterOrEqual:
                // Higher or equal values are positive
                if (!planned) return 0;
                ratio = (achieved / planned) * 100;
                break;

            case KpiCalculationType.LessOrEqual:
                // Lower or equal values are positive
                
                if (achieved === 0) {
                    ratio = 100;
                } else if (planned === 0) {
                    ratio = 0;
                } else {
                    ratio = (planned / achieved) * 100;
                }
                break;

            case KpiCalculationType.ExactlyEqual:
                // Only exact match is positive
                if (planned === 0) {
                    ratio = achieved === 0 ? 100 : 0;
                } else if (achieved === 0) {
                    ratio = 0;
                } else {
                    ratio = achieved < planned ? (achieved / planned) * 100 : (planned / achieved) * 100;
                }
                break;

            default:
                // Fallback to old logic if CalculationType is not set
                if (!planned) return 0;
                ratio = (achieved / planned) * 100;
                break;
        }

        // Cap at max result if specified
        if (maxResult && ratio > maxResult)
        {
            ratio = maxResult;
        }

        return ratio;
    }
}